import React, { useState, useEffect, useContext } from "react";
import { getAllBanks } from "../../../stores/services/bank.service";
import { getBranchByBankName } from "../../../stores/services/branch.service";
import { EditAccount } from "../../../stores/services/account.service";
import { getFundByAmc } from "../../../stores/services/funds.service";
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import NumberFormat from "react-number-format";
import {
  getNewChartsOfAccountsByFund,
  replaceChartOfAccountsFile,
} from "../../../stores/services/chatofaccounts.service";
import { GetChartOfAccount } from "../../../redux/actions/chartOfAccount-Actions";
import { useSelector, useDispatch } from "react-redux";
import { Autocomplete, Paper, TextField } from "@mui/material";
import { ThemeContext } from "../../../contexts/ThemeContext";
import { getAllLedgers, numberWithCommas } from "../../../utils/customFunction";

const ViewAccountComponent = () => {
  const history = useHistory();
  const amcCode = sessionStorage.getItem("amc_code") || "";
  const obj = JSON.parse(sessionStorage.getItem("accountObj") || "{}");
  const context = useContext(ThemeContext);
  const dispatch = useDispatch();
  //hooks for getting all inputs from user
  const [bankname, setBankName] = useState("");
  const [branchName, setBranchName] = useState("");
  const [amcName, setAmcName] = useState("");
  const [city, setCity] = useState("");
  const [fund, setFund] = useState("");
  const [currency, setCurrency] = useState("PKR");
  const [txNature, setTxNature] = useState("");
  const [iban, setIban] = useState("");
  const [glCode, setGlCode] = useState(0);
  const [opHeadEmail, setHeadEmail] = useState("");
  const [accType, setAccType] = useState("");
  const [accPurpose, setAccPurpose] = useState("");
  const [amount, setAmount] = useState("");
  const email = sessionStorage.getItem("email") || "";
  const [smaCheck, setSmaCheck] = useState<boolean>(false);
  const [acc_code, setAccCode] = useState("");
  useEffect(() => {
    setBranchHeadEmail(obj.bm_email);
    setFolioNo(obj.folio_no);
    setAccCode(obj.account_code);
    setBankName(obj.bank_name);
    setBranchName(obj.branch_name);
    setAmcName(obj.amc_code);
    if (obj.sma === "true") {
      setSmaCheck(true);
    } else {
      setSmaCheck(false);
    }
    // setSmaCheck(true);
    setFund(obj.fund_code);
    setCurrency(obj.currency);
    setBranchHeadMobile(obj.bm_phone);
    setTxNature(obj.nature_of_account);
    setIban(obj.account_no);
    setGlCode(obj.gl_code);
    setHeadPhone(obj.operation_head_phone);
    setAccType(obj.account_title);
    setAccPurpose(obj.product_purpose);
    setHeadEmail(obj.operation_head_email);
    setAmount(obj.balance_amount);
    setCity(obj.bank_city);
    setAccruedProfit(obj.accrued_profit || 0);
  }, []);

  const [headPhone, setHeadPhone] = useState("");
  const [branchHeadEmail, setBranchHeadEmail] = useState("");
  const [branchHeadMobile, setBranchHeadMobile] = useState("");
  const [folioNo, setFolioNo] = useState("");

  const [currentBalance, setCurrentBalance] = useState(
    obj?.balance_amount?.toFixed(4) || "0"
  );
  const [currentBalanceError, setCurrentBalanceError] =
    useState<boolean>(false);

  const [interestRate, setInterestRate] = useState<any>("");
  const [accruedProfit, setAccruedProfit] = useState<any>(0);
  const [debitBankProfitLedger, setDebitBankProfitLedger] = useState<any>();
  const [creditBankProfitLedger, setCreditBankProfitLedger] = useState<any>();
  const [associatedLedgerExpense, setAssociatedLedgerExpense] = useState<any>();
  const [interestRateError, setInterestRateError] = useState<boolean>(false);
  const [debitBankProfitLedgerError, setDebitBankProfitLedgerError] =
    useState<boolean>(false);
  const [creditBankProfitLedgerError, setCreditBankProfitLedgerError] =
    useState<boolean>(false);
  const [associatedLedgerExpenseError, setAssociatedLedgerExpenseError] =
    useState<boolean>(false);

  const [ledgerOption, setLedgerOption] = useState<any>([]);
  const [allLedgerData, setAllLedgerData] = useState<any>([]);

  // const chartOfAccounts = useSelector((state: any) => state.chartofAccounts);
  const [chartOfAccounts, setChartOfAccounts] = useState<any>(undefined);

  const [ledgersOptionFlag, setLedgersOptionFlag] = useState(false);

  useEffect(() => {
    if (chartOfAccounts?.length > 0) {
      setLedgersData();
    }
  }, [chartOfAccounts]);

  const setLedgersData = async () => {
    let temp = await getAllLedgers(chartOfAccounts);
    setAllLedgerData([...temp]);
  };

  useEffect(() => {
    setLedgersOptionFlag(false);
    allLedgerData.map((item, index) => {
      if (index === 0) {
        if (item.name) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.name}`,
              value: item.code,
            },
          ]);
        } else if (item.bank) {
          return setLedgerOption([
            {
              label: `${item.code} - ${item.bank}`,
              value: item.code,
            },
          ]);
        }
      }

      if (item.name) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.name}`,
            value: item.code,
          },
        ]);
      } else if (item.bank) {
        return setLedgerOption((prevState) => [
          ...prevState,
          {
            label: `${item.code} - ${item.bank}`,
            value: item.code,
          },
        ]);
      }
    });

    allLedgerData.length > 0 && setLedgersOptionFlag(true);
  }, [allLedgerData]);

  useEffect(() => {
    if (obj.gl_code && ledgersOptionFlag == true) {
      let findAccountsDetails = chartOfAccounts[0].family[3].sub_family
        ?.find(
          (item) =>
            item.name ==
            (obj.nature_of_account == "Current"
              ? "CURRENT ACCOUNTS"
              : "PLS ACCOUNTS")
        )
        ?.gl.find((item) => item.code == obj.gl_code);
      setInterestRate(findAccountsDetails?.interest_rate || "");
      // setCurrentBalance(findAccountsDetails?.balance || "0");

      if (
        ledgerOption &&
        ledgerOption.find(
          (item) => item.value == findAccountsDetails?.related_ledgers[0]
        )
      ) {
        setDebitBankProfitLedger(
          ledgerOption.find(
            (item) => item.value == findAccountsDetails?.related_ledgers[0]
          )
        );
      }
      if (
        ledgerOption &&
        ledgerOption.find(
          (item) => item.value == findAccountsDetails?.related_ledgers[1]
        )
      ) {
        setCreditBankProfitLedger(
          ledgerOption.find(
            (item) => item.value == findAccountsDetails?.related_ledgers[1]
          )
        );
      }
    }
  }, [ledgersOptionFlag]);

  const getChartOfAccountsFromBackend = async () => {
    try {
      let response = await getNewChartsOfAccountsByFund(email, amcCode, fund);
      if (response.data.status === 200) {
        setChartOfAccounts(response.data.data?.main_family);
      } else {
        toast.error("No associated chart of account!");

        setChartOfAccounts(undefined);
      }
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message?.toString());
      } else {
        toast.error(err.message || "Request Failed!");
      }
    }
  };

  useEffect(() => {
    if (fund) {
      getChartOfAccountsFromBackend();
    }
  }, [fund]);

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="input-holder">
                <h4 className="card-title">
                  <i
                    className="fa fa-angle-left mr-1 pointer"
                    onClick={() => {
                      sessionStorage.removeItem("accountObj");
                      history.replace("/admin/bank-accounts");
                    }}
                  ></i>
                  View - Bank Account
                </h4>
                <Link
                  to="/admin/bank-accounts"
                  className="btn btn-primary btn-sm"
                  replace
                >
                  <i className="fa fa-eye mr-2"></i> View All
                </Link>
              </div>

              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Fund Detail</h4>
                    </div>
                    <div className="card-body">
                      {/* <div className="form-group  ">
                    <label>AMC Name</label>
                    <div className="  disable">
                      <input
                        type="text"
                        className="form-control "
                        style={{ opacity: '0.6' }}
                        value={amcName}
                        readOnly
                      />
                    </div>
                  </div> */}

                      <div className="form-group  ">
                        <label>
                          Fund Selection <span className="color-amber">*</span>
                        </label>
                        <div>
                          <input
                            className={`form-control  w-100 `}
                            value={fund}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Bank Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group  ">
                        <label>Bank Name</label>
                        <div>
                          <input
                            className={`form-control  w-100 `}
                            value={bankname}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group  ">
                            <label>Branch Name</label>
                            <input
                              type="text"
                              className="form-control"
                              value={branchName}
                              disabled
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              City <span className="color-amber">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={city}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Special Managed Account</h4>
                    </div>
                    <div className="card-body">
                      <FormGroup check className="mt-4">
                        <Label check>
                          <Input type="checkbox" checked={smaCheck} />
                          <span className="form-check-sign" />
                          SMA (Optional)
                        </Label>
                      </FormGroup>

                      {smaCheck && (
                        <div className="form-group mt-4">
                          <label>Main Folio No</label>
                          <div>
                            <input
                              type="text"
                              className="form-control"
                              value={folioNo}
                              disabled
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Contact Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group  ">
                        <label>Operation Manager Email</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 `}
                            value={opHeadEmail}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Operation Manager Phone</label>
                        <div>
                          <PhoneInput
                            specialLabel=""
                            inputClass={`form-control  w-100 `}
                            country={"pk"}
                            placeholder="+92 123-1234567"
                            value={headPhone}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Branch Manager Phone</label>
                        <div>
                          <PhoneInput
                            specialLabel=""
                            inputClass={`form-control  w-100`}
                            country={"pk"}
                            placeholder="+92 123-1234567"
                            value={branchHeadMobile}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Branch Manager Email</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 `}
                            value={branchHeadEmail}
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md="4">
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Account Detail</h4>
                    </div>
                    <div className="card-body">
                      <div className="form-group  ">
                        <label>Bank Account Title</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 `}
                            value={accType}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>IBAN</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100 `}
                            value={iban}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Ledger Code</label>
                        <div>
                          <input
                            type="text"
                            className={`form-control  w-100`}
                            value={glCode}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Nature of Account</label>
                        <div>
                          <input
                            className={`form-control  w-100 `}
                            value={txNature}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Currency</label>
                        <div>
                          <input
                            className={`form-control  w-100 `}
                            value={currency}
                            disabled
                          />
                        </div>
                      </div>

                      <div className="form-group  ">
                        <label>Current Balance</label>
                        <div className="  disable-input">
                          <input
                            type="text"
                            value={numberWithCommas(
                              parseFloat(currentBalance || "0")?.toFixed(4)
                            )}
                            className={`form-control w-100 `}
                            style={{ textAlign: "right" }}
                            disabled
                          />
                        </div>
                      </div>

                      {txNature === "PLS" ? (
                        <div className="form-group">
                          <label>Interest Rate % </label>
                          <input
                            type="number"
                            value={parseFloat(interestRate || "0")?.toFixed(4)}
                            className={`form-control w-100 `}
                            style={{ textAlign: "right" }}
                            disabled
                          />
                        </div>
                      ) : null}

                      {/* {txNature === "PLS" ? (
                        <div
                          className="form-group"
                          data-tip="Currently Accumulated Profit for Bank"
                        >
                          <label>Accrued Profit</label>
                          <input
                            type="text"
                            disabled
                            placeholder="0"
                            value={
                              accruedProfit != 0
                                ? numberWithCommas(
                                    parseFloat(accruedProfit)?.toFixed(4)
                                  )
                                : 0
                            }
                            className={`form-control w-100`}
                            style={{ textAlign: "right" }}
                          />
                        </div>
                      ) : null} */}

                      {txNature === "PLS" ? (
                        <div
                          className="form-group"
                          data-tip="Ledger Codes to Debit/Credit in case of bank profit"
                        >
                          <div>
                            Associated Ledger Codes (for profit accrual)
                          </div>
                          <small className={`mt-2 `}>Debit Ledger</small>
                          <input
                            className={`form-control w-100`}
                            disabled
                            data-tip="Ledger Code to associate in case of Expense"
                            id="combo-box-demo"
                            style={{ width: "100%" }}
                            value={debitBankProfitLedger?.label || ""}
                          />
                          <small className={`mt-2 `}>Credit Ledger</small>
                          <input
                            className={`mt-2 form-control w-100`}
                            disabled
                            data-tip="Ledger Code to associate in case of Expense"
                            id="combo-box-demo"
                            value={creditBankProfitLedger?.label || ""}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </Col>
              </Row>

              <div className="d-flex ">
                <div className=" ">
                  <button
                    className="btn btn-default"
                    onClick={() => {
                      sessionStorage.removeItem("accountObj");
                      history.replace("/admin/bank-accounts");
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ViewAccountComponent;
